/* eslint-disable @next/next/no-img-element */
import React, { useContext } from 'react';
import {
  GOOGLE_BUTTON_TEXT,
  GOOGLE_BUTTON_IMG_TEXT,
} from '../../../brands/default/content/components/checkout';
import { GOOGLE_BUTTON_IMG } from '../../../config/constants/images';
import ThemeContext from '../../../providers/ThemeProvider';

const GoogleButton = () => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <img
        alt={GOOGLE_BUTTON_IMG_TEXT}
        className="google"
        src={GOOGLE_BUTTON_IMG}
      />
      <span className="sr-only">{GOOGLE_BUTTON_TEXT}</span>
      <style jsx>{`
        .google {
          width: 85%;
          padding: 5px;
        }
        @media (max-width: ${theme.breakpoints.xlDown}) {
          .google {
            width: 90%;
            padding: 10px;
          }
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          .google {
            width: 90%;
            padding: 12px;
          }
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .google {
            width: 90%;
            padding: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default GoogleButton;
